import { render, staticRenderFns } from "./LectureLessonInfoInformation.vue?vue&type=template&id=24c60ef5&"
import script from "./LectureLessonInfoInformation.vue?vue&type=script&lang=js&"
export * from "./LectureLessonInfoInformation.vue?vue&type=script&lang=js&"
import style0 from "./LectureLessonInfoInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports